import React from 'react';
import styled, { useTheme } from 'styled-components';
import { User2 as UserIcon } from 'lucide-react';
import EllipsisMenu from '../Layout/EllipsisMenu';

const Card = styled.div`
  width: 150px;
  height: 180px;
  background: var(--bg-panel, #f7f9fa);
  border: 1.5px solid var(--border-color, #e0e4ea);
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 4px;
  padding: 18px 10px 10px 10px;
  box-sizing: border-box;
  position: relative;
`;

const Avatar = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: var(--bg-avatar, #e3e7ef);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin-bottom: 12px;
  border: 2px solid var(--border-color, #e0e4ea);
`;

const Username = styled.div`
  font-weight: 700;
  font-size: .75rem;
  color: var(--text-main, #222);
  margin-bottom: 2px;
  text-align: center;
  word-break: break-all;
`;

const Name = styled.div`
  font-size: 0.88rem;
  color: var(--text-secondary, #555);
  margin-bottom: 8px;
  text-align: center;
`;

const Roles = styled.div`
  font-size: 0.85rem;
  color: var(--text-tertiary, #888);
  margin-top: auto;
  text-align: center;
`;

const UserCard = ({ user }) => {
  if (!user) return null;
  const { avatarFile, username, email, firstname, lastname, roles } = user;

  const handleShare = () => {
        // Add your share logic here
  };

  const handleDelete = () => {
        // Add your delete logic here
  };

  return (
    <Card>
      <EllipsisMenu 
        onShare={handleShare}
        onDelete={handleDelete}
        size={16}
      />
      <Avatar>
        {avatarFile ? (
          <img
            src={avatarFile}
            alt={username || email}
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        ) : (
          <UserIcon size={40} color="#b0b8c9" />
        )}
      </Avatar>
      <Username>{username || email}</Username>
      <Name>{firstname} {lastname}</Name>
      {/* <Roles>{roles && roles.length > 0 ? roles.join(', ') : null}</Roles> */}
    </Card>
  );
};

export default UserCard; 